<template>
    <header class="">
        <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" :class="{'pt-[29px]': hideNavigation}" aria-label="Global">
            <div class="flex lg:flex-1">
                <a href="/" class="-m-1.5 p-1.5">
                    <span class="sr-only">Landscape</span>
                    <img class="h-8 w-auto" src="/img/2023/logo.png" alt="Landscape Logo" >
                </a>
            </div>
            <div class="flex lg:hidden">
                <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700" @click="mobileMenuOpen = true">
                    <span class="sr-only">Open main menu</span>
                    <Bars3Icon class="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
            <PopoverGroup v-if="!hideNavigation"  class="hidden lg:flex lg:gap-x-3 rounded-[46px] items-center shadow border border-gray-200 bg-white p-2">
                <div v-for="(item, index) in navigation" :key="index">
                    <component
                        :is="item.element"
                        v-if="!item.children"
                        :href="item.href"
                        :target="item.external ? '_blank' : '_self'"
                        :class="[item.current ? 'text-zinc-800 bg-neutral-100' : 'text-zinc-400', 'text-sm font-medium leading-tight rounded-full px-3 h-7 flex items-center hover:text-zinc-800 hover:bg-neutral-100 inline-block']"
                    >

                        <span v-if="item.current" class="w-2 h-2 bg-zinc-800 rounded-full mr-[6px]"/>


                        <span>{{ item.name }}</span>



                    </component>

                    <Popover v-else class="relative">
                        <PopoverButton :class="[item.current ? 'text-zinc-800 bg-neutral-100' : 'text-zinc-400', 'text-sm font-medium rounded-full  leading-tight px-3 h-7 flex items-center hover:text-zinc-800 hover:bg-neutral-100']">
                            <span v-if="item.current" class="w-2 h-2 bg-zinc-800 rounded-full mr-[6px]"/>

                            <span>{{ item.name }}</span>
                            <ChevronDownIcon class="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                        </PopoverButton>

                        <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
                            <PopoverPanel class="absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                                <component :is="subItem.element" v-for="subItem in item.children" :key="subItem.name" :href="subItem.href" :class="[subItem.current ? 'text-zinc-800': 'text-zinc-400', 'w-full rounded-lg px-3 py-2 text-sm block font-medium leading-tight hover:bg-neutral-100 hover:text-zinc-800']">

                                    <div class="flex items-center">
                                        <component is="svg" v-if="subItem.svg" class="w-4 h-4 mr-2 inline-block" v-html="subItem.svg" />

                                        <span>{{ subItem.name }}</span>

                                    </div>


                                    <span v-if="subItem.description" class=" text-xs ml-auto pl-[24px] mt-[1px] block">{{ subItem.description }}</span>
                                </component>
                            </PopoverPanel>
                        </transition>
                    </Popover>
                </div>


            </PopoverGroup>
            <div class="hidden lg:flex lg:flex-1 lg:justify-end">


                <button v-if="user && user.signals_enabled" data-canny-changelog class="flex rounded-full hover:border-zinc-800 text-zinc-800 hover:text-zinc-800 justify-center shadow border border-gray-200  mr-4 items-center w-9 h-9">
                    <MegaphoneIcon class="h-5 w-5 " aria-hidden="true" />
                </button>

                <Popover  v-if="user" class="relative">
                    <PopoverButton :class="['text-zinc-800 text-sm font-medium rounded-full  leading-tight  flex items-center hover:text-zinc-800 ']">
                        <img
                            class="inline-block h-9 w-9 rounded-full object-cover mr-2"
                            :src="$page.props.user.profile_photo_url"
                            alt="">
                        <span>{{ user.name }}</span>
                        <ChevronDownIcon class="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                    </PopoverButton>

                    <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
                        <PopoverPanel class="absolute -left-8 top-full z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/5">
                            <Link v-for="item in accountNavigation" :key="item.name" :method="item.method" :href="item.href" :class="[item.current ? 'text-zinc-800': 'text-zinc-400', 'block rounded-lg px-3 py-2 text-sm font-medium leading-tight hover:bg-neutral-100 hover:text-zinc-800']">{{ item.name }}</Link>
                        </PopoverPanel>
                    </transition>
                </Popover>


                <div v-else>

                    <Link  :href="route('login')" class="text-neutral-500 text-sm font-medium leading-tight mr-4">Login</Link>

                    <Link :href="route('register')" class=" h-9 px-4  bg-zinc-800 rounded-[100px] justify-center items-center gap-2 inline-flex text-white text-sm font-medium leading-none">
                        Create an Account
                    </Link>
                </div>

            </div>
        </nav>
        <Dialog as="div" class="lg:hidden" :open="mobileMenuOpen" @close="mobileMenuOpen = false">
            <div class="fixed inset-0 z-10" />
            <DialogPanel class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                <div class="flex items-center justify-between">
                    <a href="#" class="-m-1.5 p-1.5">
                        <span class="sr-only">Landscape</span>
                        <img class="h-8 w-auto" src="/img/2023/logo-icon.svg" alt="Landscape" >
                    </a>
                    <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700" @click="mobileMenuOpen = false">
                        <span class="sr-only">Close menu</span>
                        <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <div class="mt-6 flow-root">
                    <div class="-my-6 divide-y divide-gray-500/10">
                        <div class="space-y-2 py-6">


                            <div v-for="(item, index) in navigation" :key="index">

                                <component :is="item.element" v-if="!item.children" :href="item.href" :class="[item.current ? 'text-zinc-800' : 'text-zinc-400', '-mx-3 block rounded-lg px-3 py-2 text-base font-medium leading-7  hover:text-zinc-800  hover:bg-gray-50']">{{ item.name }}</component>


                                <Disclosure v-if="item.children" v-slot="{ open }" as="div" class="-mx-3">
                                    <DisclosureButton :class="['flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-medium leading-7 text-gray-900 hover:bg-gray-50']">
                                        {{ item.name }}
                                        <ChevronDownIcon :class="[open ? 'rotate-180' : '', 'h-5 w-5 flex-none']" aria-hidden="true" />
                                    </DisclosureButton>
                                    <DisclosurePanel class="mt-2 space-y-2">
                                        <component :is="subItem.element" v-for="subItem in item.children" :key="subItem.name"  :href="subItem.href" :class="[subItem.current ? 'text-zinc-800' : 'text-zinc-400', 'block rounded-lg py-2 pl-6 pr-3 text-sm font-medium leading-7   hover:text-zinc-800  hover:bg-gray-50']">{{ subItem.name }}</component>
                                    </DisclosurePanel>
                                </Disclosure>

                            </div>

                        </div>
                        <div v-if="!user" class="py-6">

                            <div class="flex items-center">
                                <Link :href="route('register')" class=" h-9 px-4  bg-zinc-800 rounded-[100px] justify-center items-center gap-2 inline-flex text-white  font-medium leading-none mr-4">
                                    Create an Account
                                </Link>


                                <Link :href="route('login')" :class="['-mx-3 block rounded-lg px-3 py-2.5 text-base font-medium leading-7 text-gray-900 hover:bg-gray-50']">Login</Link>
                            </div>

                        </div>
                        <div v-else >
                            <Link v-for="item in accountNavigation" :href="item.href" :method="item.method" :class="[item.current ? 'text-zinc-800' : 'text-zinc-400', '-mx-3 block rounded-lg px-3 py-2.5 text-base font-medium leading-7 hover:text-zinc-800 hover:bg-gray-50']">{{ item.name }}</Link>
                        </div>
                    </div>
                </div>
            </DialogPanel>
        </Dialog>
    </header>
</template>

<script>
import {
    Dialog,
    DialogPanel,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/vue';
import {
    ArrowPathIcon,
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,
    MegaphoneIcon,
    SquaresPlusIcon,
    XMarkIcon,
} from '@heroicons/vue/24/outline';
import { ChevronDownIcon  } from '@heroicons/vue/20/solid';
import { Link } from '@inertiajs/vue3';

export default {
    components: {
        ChevronDownIcon,
        Bars3Icon,
        MegaphoneIcon,
        XMarkIcon,
        Dialog,
        DialogPanel,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Popover,
        Link,
        PopoverButton,
        PopoverGroup,
        PopoverPanel,
    },
    props: ['navigation', 'accountNavigation', 'user', 'hideNavigation'],
    data() {
        return {
            mobileMenuOpen: false,
        };
    },

    mounted() {
        Canny('initChangelog', {
            appID: '61d21d63a4d85115def7fb51',
            position: 'bottom',
            align: 'right',
            theme: 'light', // options: light [default], dark, auto
        });
    },
};
</script>
